
(function(){
  var rail=document.querySelector('#shopify-section-template--25519329018049__rail .r-rail');
  if(!rail)return;
  var baseTop=20;
  function upd(){
    var h1=document.querySelector('h1');
    var lim=document.querySelector('.shopify-section[id*="__comments"]')||document.querySelector('.s2-disc')||document.querySelector('.s2-foot');
    if(window.innerWidth<1240){rail.style.top='';rail.style.transform='';return;}
    var top=baseTop;
    if(h1){var hd=h1.getBoundingClientRect().top;if(hd>baseTop)top=hd;}
    var maxTop=window.innerHeight-rail.offsetHeight-16;
    if(top>maxTop)top=maxTop;
    var floorEl=document.querySelector('.s2-crumbwrap');
    var floor=12;
    if(floorEl){var fb=floorEl.getBoundingClientRect().bottom+10;if(fb>floor)floor=fb;}
    if(top<floor)top=floor;
    rail.style.top=top+'px';
    if(lim){
      var lv=lim.getBoundingClientRect().top;
      var over=(top+rail.offsetHeight)-(lv-24);
      rail.style.transform=over>0?'translateY(-'+over+'px)':'';
    }
  }
  function place(){
    if(window.innerWidth>=1240)return;
    var sec=document.getElementById('shopify-section-template--25519329018049__rail');
    var target=document.querySelector('.shopify-section[id*="__comments"]');
    if(!target){var disc=document.querySelector('.s2-disc')||document.querySelector('.s2-foot');target=disc?disc.closest('.shopify-section'):null;}
    if(sec&&target&&sec.nextElementSibling!==target){target.parentNode.insertBefore(sec,target);}
  }
  ['scroll','resize'].forEach(function(e){window.addEventListener(e,function(){requestAnimationFrame(upd)},{passive:true})});
  window.addEventListener('resize',place);
  window.addEventListener('load',function(){place();upd();});
  place();upd();
})();
